import { combineReducers } from 'redux';
import adminReducer from './adminReducer';
import widthHeightReducer from './widthHeightReducer';
import restaurantReducer from './restaurantReducer';

const rootReducer = combineReducers({ admin: adminReducer, wh: widthHeightReducer, restaurant: restaurantReducer });

export default rootReducer;
